module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ui-login-Artboard-4@2x.ca22ba74.png";